/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import clsx from 'clsx';
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { Toast } from 'react-bootstrap';
import { Buffer } from 'buffer';
import { actionCreators } from '../../../store/actions/user';
import { useDispatch } from 'react-redux';
import { useAuth } from '../core/Auth';
import Data from '../../../utils/SetGetData';
import axios from "axios";
import Select from 'react-select';
import { KTSVG } from '../../../../_vtsl/helpers';


const loginSchema = Yup.object().shape({
  email: Yup.string()

    .required('Email is required'),
  password: Yup.string()
    .required('Password is required'),
});
const initialValues = {
  email: '',
  password: '',
};
/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/
export function ResellerLogin() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [userName, setUserName] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [oldpassword, setOldpassword] = useState('');
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [selectReseller, setSelectReseller] = useState([]);
  const [sToken, setStoken] = useState('');
  const [bToken, setBtoken] = useState('');
  const [tid, setTid] = useState('');
  const navigate = useNavigate();
  const [selectedReseller, setSelectedReseller] = useState('');

  useEffect(() => {
    // Set the first object from selectReseller as default on component mount
    if (selectReseller && selectReseller.length > 0) {
      setSelectedReseller({
        label: selectReseller[0].tname,
        value: selectReseller[0].tid
      });
    }
  }, [selectReseller]);


  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: 'black', // Set the color of options to black
    }),
    singleValue: (provided, state) => ({
      ...provided,
      display: 'block', // Display the selected value
    }),
  };


  const { saveAuth, setCurrentUser } = useAuth();
  const dispatch = useDispatch()



  const resellerLogin = (user) => dispatch(actionCreators.resellerLogin(user))
  const success = (res) => {
    setLoading(false)
    Data.setData('tenantInfoData', res.tenantInfo);

    setSelectReseller(res.tenantInfo)

    if (res === 'Success and change password') {
      return setChangePassword(true)
    }
    setStoken(res.s_token)
    setBtoken(res.b_token)
    Data.setData('userResellerId', res.id);
    Data.setData('ResellerName', res.name);
  }
  const failure = (err) => {
    setLoading(false)
    setError(true)
    setSelectReseller([])

    console.log('failure Login', err)
  }
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setUserName(values.email)
      setOldpassword(values.password)
      resellerLogin({
        values,
        success,
        failure
      });

    },
  });
  const changePasswordHandler = () => {
    if (newPassword !== confirmPassword) {

      toast.error('Passwords doesnot match!');
      return;
    }
    if (passwordStrength < 4) {
      toast.error('Password should have atleast 1 of $@#&! special character, 1 number, 1 lower case letter and 1 upper case letter!');
      toast.error('Password is weak');
      return;
    }
    const usernameLowered = userName.toLowerCase();
    const payLoad = {
      username: usernameLowered,
      old_password: oldpassword,
      new_password: newPassword
    }
    axios.post(`${process.env.REACT_APP_API_URL}changeAppPassword`, payLoad)
      .then(response => {
        toast.success('Passwords Change Successfully , SignIn with new password');
        setChangePassword(false);
      })
      .catch(err => {
        // toast.error(err.response.data);
      });

  }
  const passwordKeyUpHandler = (evt) => {
    const strengthbar = document.getElementById("meter");
    const pass = evt.target.value;
    setError('');
    var strength = 0;
    if (pass.match(/[a-z]+/)) {
      strength += 1;
    }
    if (pass.match(/[A-Z]+/)) {
      strength += 1;
    }
    if (pass.match(/[0-9]+/)) {
      strength += 1;
    }
    if (pass.match(/[$@#&!]+/)) {
      strength += 1;

    }

    if (pass.length < 8) {
      setError('Minimum number of characters are 8');
      strength -= 1;
    }
    if (pass.length > 100) {
      setError('Maximum number of characters are 100');
      strength -= 1;
    }
    if (pass.length >= 6 && pass.length <= 12) {

    }

    switch (strength) {
      case 0:
        strengthbar.style.width = '0%';
        strengthbar.style.backgroundColor = "red";
        break;

      case 1:
        strengthbar.style.width = '25%';
        strengthbar.style.backgroundColor = "red";
        break;

      case 2:
        strengthbar.style.width = '50%';
        strengthbar.style.backgroundColor = "orange";
        break;

      case 3:
        strengthbar.style.width = '75%';
        strengthbar.style.backgroundColor = "orange";
        break;

      case 4:
        strengthbar.style.width = '100%';
        strengthbar.style.backgroundColor = "#22af47";
        break;
    }

    setPasswordStrength(strength);
  }


  const handledomainList = (selectedOption) => {
    setSelectedReseller(selectedOption); // Assuming this updates the state for selectedReseller
    setTid(selectedOption.value); // Assuming this updates the state for tid
    Data.setData('CurrentTId',selectedOption.value);
    setUserName(selectedOption.label); // Assuming this updates the state for userName
    Data.setData('ResellerTenantName', selectedOption.label); // Setting data using Data.setData (assuming it's a function/method)
  };
  const loginFun = () => {
    if (tid === '') {
      return toast.error('Please select Tanent');
    }
    else {
      Data.setData('B_Token', bToken);
      Data.setData('S_Token', sToken);
      Data.setData('userTenantId', sToken);

      const userInfo = {
        'admin': true,
        'firstname': localStorage.getItem('ResellerName'),

        'tenant_id': tid.toString(),
      }
      // saveAuth(bToken);
      setCurrentUser(userInfo);
      Data.setData('user_type', 'admin');
      Data.setData('ShowLogout', true);
      Data.setData('tanentLogin', false);

      navigate('/userManagemnet')

    }

  }
  return (<div>
    {!changePassword ? <form className='form w-100' onSubmit={formik.handleSubmit} noValidate id='kt_login_signin_form'>

      {selectReseller.length <= 1 ? <div>
        <div className='text-center mb-10'>
          <h1 className='text-dark mb-3'>Sign In to Reseller VCX</h1>
          {/* <div className='text-gray-400 fw-bold fs-4'>
            New Here?{' '}
            <Link to='/auth/registration' className='link-primary fw-bolder'>
              Create an Account
            </Link>
          </div> */}
        </div>



        {/* begin::Form group */}
        <div className='fv-row mb-10'>
          <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
          <input placeholder='Email' {...formik.getFieldProps('email')} className={clsx('form-control form-control-lg form-control-solid')} type='email' name='email' autoComplete='off' />
          {formik.touched.email && formik.errors.email && (<div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>)}
        </div>

        <div className='fv-row mb-10'>
          <div className='d-flex justify-content-between mt-n5'>
            <div className='d-flex flex-stack mb-2'>

              <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>

              <Link to='/auth/forgot-password-reseller' className='link-primary fs-6 fw-bolder' style={{ marginLeft: '5px' }}>
                Forgot Password ?
              </Link>

            </div>
          </div>
          <input placeholder='Password' type='password' autoComplete='off' {...formik.getFieldProps('password')} className={clsx('form-control form-control-lg form-control-solid')} />
          {formik.touched.password && formik.errors.password && (<div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>)}
          {error ? <span style={{ color: 'red' }} role='alert'>Invalid Credentials! </span> : null}
        </div>


        {/* begin::Action */}
        <div className='text-center'>
          <button type='submit' id='kt_sign_in_submit' className='primary-button-New w-100 mb-5' disabled={formik.isSubmitting || !formik.isValid}>
            {!loading && <span className='indicator-label'>Sign In</span>}
            {loading && (<span className='indicator-progress' style={{ display: 'block' }}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>)}
          </button>
        </div>
      </div> : selectReseller && selectReseller.length > 1 ? (
        <div className={'row my-3 '} style={{ "alignItems": 'center' }}>
          <h1 className='text-dark mb-3 d-flex align-self-center'>Select The Tenant </h1>
          {selectReseller ? (
            <Select
              className="basic-single"
              classNamePrefix="select"
              onChange={handledomainList}
              options={[
                { label: "Select an option", value: "" }, // Empty select option
                ...selectReseller.map(option => ({
                  label: option.tname,
                  value: option.tid
                }))
              ]}
              styles={customStyles}
            />
          ) : null}
          <div style={{ display: 'flex', marginTop: 20 }}>
            <button onClick={loginFun} className='btn btn-lg w-30 btn-light-primary me-3' type="button"><span className='indicator-label'>   Login As A Tenant</span></button>
            <button onClick={() => { setSelectReseller([]) }} type='button' className='btn btn-lg w-30 btn-light-danger me-3'>
              Cancel
            </button>
          </div>


        </div>
      ) : null}

    </form> :
      <div className='form w-100' >

        <div>
          <div className='text-center mb-10'>
            <h1 className='text-dark mb-3'>Change Password</h1>

          </div>
          {/* begin::Heading */}

          {/* {formik.status ? (<div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>) : (<div className='mb-10 bg-light-info p-8 rounded'>
          <div className='text-info'>
            Use account <strong>admin@demo.com</strong> and password <strong>demo</strong> to
            continue.
          </div>
        </div>)} */}



          {/* begin::Form group */}
          <div className='fv-row mb-10'>
            <div className='d-flex justify-content-between mt-n5'>
              <div className='d-flex flex-stack mb-2'>
                {/* begin::Label */}
                <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
                {/* end::Label */}
              </div>
            </div>
            <input onKeyUp={passwordKeyUpHandler} placeholder='Password' type='password' value={newPassword} onChange={(e) => { setNewPassword(e.target.value) }} autoComplete='off' className={clsx('form-control form-control-lg form-control-solid')} />
            <div className="progress mt-5"><div id="meter" className="progress-bar" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" ></div></div>
            {error ? <span style={{ color: 'red' }} role='alert'>{error} </span> : null}
          </div>
          <div className='fv-row mb-10'>
            <div className='d-flex justify-content-between mt-n5'>
              <div className='d-flex flex-stack mb-2'>
                {/* begin::Label */}
                <label className='form-label fw-bolder text-dark fs-6 mb-0'>Confirm Password</label>
                {/* end::Label */}
              </div>
            </div>
            <input onKeyUp={passwordKeyUpHandler} placeholder='Password' type='password' autoComplete='off' value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value) }} className={clsx('form-control form-control-lg form-control-solid')} />

          </div>
          {/* end::Form group */}

          {/* begin::Action */}
          <div className='text-center'>
            <button onClick={() => changePasswordHandler()} className='primary-button-New w-100 mb-5' >
              <span className='indicator-label'>Change Password</span>

            </button>
          </div>
        </div>
        {/* end::Action */}
      </div>}
  </div>);
}


